/**
 * @link https://mui.com/material-ui/react-box/
 * @link https://mui.com/material-ui/customization/dark-mode/
 */

import { Box } from '@mui/material';

export default function FactureeBackground(props) {
  return (
    <>
      <Box
        sx={{
          display: 'block',
          margin: 'auto',
          width: '100%',
          maxWidth: '100vw',
          bgcolor: 'background.default',
          color: 'text.primary',
          borderRadius: 0,
        }}
      >
        {props.children}
      </Box>
    </>
  );
}
